export default function GoogleMap() {
  return (
    <section className="bg-black py-20 lg:py-28 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="text-center text-3xl sm:text-4xl font-bold text-[#DC2626] mb-10">
          OUR LOCATION AREA IN THE GOOGLE MAP
        </h2>
        <div className="border border-[#262626] overflow-hidden">
          <iframe
            title="Act Fast Appliance Repair Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3549.4442390478334!2d-87.7488424!3d41.97368900000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e39c68f17314f%3A0xf977708188a81e0c!2sAct%20Fast%20Appliance%20Repair!5e1!3m2!1sen!2sph!4v1782740479991!5m2!1sen!2sph"
            width="100%"
            height="450"
            style={{ border: 0, filter: "grayscale(0.6) contrast(1.1)" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
    </section>
  );
}
